import ArrowLeft from '../../src/legacy/ArrowLeft.tsx';
export default ArrowLeft;
